<template>
  <section class="section">
    <div class="container">
      <h2 class="section-title">核心技术优势</h2>
      <p class="section-lead">专为云游戏场景优化的全栈技术体系，从渲染到传输的每一个环节都经过深度调优</p>
      <div class="features-grid">
        <div v-for="f in features" :key="f.title" class="feature-card">
          <div class="feature-icon" v-html="f.icon" />
          <h3>{{ f.title }}</h3>
          <p>{{ f.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const features = [
  {
    title: '超低延迟传输',
    desc: '端到端延迟最低至5ms，采用自研视频编码协议和智能码率自适应算法，在 4K 画质下依然保持流畅的操作响应。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12,6 12,12 16,14"/></svg>'
  },
  {
    title: '高并发渲染集群',
    desc: '支持单节点多路并发渲染，GPU 资源池化调度，可根据业务负载自动弹性扩缩容，峰值支持十万级并发用户。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>'
  },
  {
    title: '多端适配 SDK',
    desc: '提供 Web、iOS、Android、Windows、Linux、智能电视等多平台 SDK，支持手柄、键鼠、触屏等多种输入方式，一次接入多端覆盖。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>'
  },
  {
    title: '边缘节点网络',
    desc: '全国32省/自治区/直辖市边缘云游戏服务覆盖，智能就近接入，提供最高4k120Hz，最低RTT延迟至5ms的电竞级游戏体验。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5M2 12l10 5 10-5"/></svg>'
  },
  {
    title: '用户管理系统',
    desc: '内置完整的用户认证、会话管理、数据统计和运营分析系统，支持自定义计费模式和用户分层策略。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>'
  },
  {
    title: 'DRM 版权保护',
    desc: '集成业界标准的数字版权管理方案，支持 Widevine、FairPlay 等 DRM 协议，保护游戏内容不被非法录制和传播。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 12l2 2 4-4"/><path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.5 0 2.91.37 4.15 1.02"/></svg>'
  }
];
</script>
